import React, { useCallback, useEffect, useState } from 'react';
import { reduxForm, Field, FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { TimePickerInput } from '../TimePicker';
import { Redirect } from 'react-router-dom';
import i18next from 'i18next';

import { Button, Modal } from 'react-bootstrap';

import { SelectInput, SelectIconRenderer } from '../SelectInput';
import { components } from 'react-select';
import { TextInput } from '../TextInput';
import { CheckboxInput } from '../CheckboxInput';
import { PageLevelAccess } from '../PageLevelAccess';
import { ThresholdsService, AlertLevelsService, EventConfigurationStatusesService, ActionsService, EventConfigurationsService, GroupsService, TagsService } from "../../services";
import { FormatHelper } from '../../helpers';

import config from "config";

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = i18next.t('messages.please-enter-name');
  }

  if (!values.description) {
    errors.description = i18next.t('messages.please-enter-description');
  }

  if (!values.status) {
    errors.status = i18next.t('messages.please-select-status');
  }

  if (values.alertConfigurationActions) {
    const alertConfigurationActionsArrayErrors = [];
    values.alertConfigurationActions.forEach((alertConfigurationAction, alertIndex) => {
      const alertConfigurationActionsErrors = {};
      if (!alertConfigurationAction || !alertConfigurationAction.action) {
        alertConfigurationActionsErrors.action = i18next.t('messages.please-select-action-type');
        alertConfigurationActionsArrayErrors[alertIndex] = alertConfigurationActionsErrors;
      }

      if (!alertConfigurationAction || !alertConfigurationAction.alertLevel) {
        alertConfigurationActionsErrors.alertLevel = i18next.t('messages.please-select-level');
        alertConfigurationActionsArrayErrors[alertIndex] = alertConfigurationActionsErrors;
      }

      if (!alertConfigurationAction || !alertConfigurationAction.duration) {
        alertConfigurationActionsErrors.duration = i18next.t('messages.please-enter-duration');
        alertConfigurationActionsArrayErrors[alertIndex] = alertConfigurationActionsErrors;
      }

      if (!alertConfigurationAction || !alertConfigurationAction.threshold) {
        alertConfigurationActionsErrors.threshold = i18next.t('messages.please-select-threshold');
        alertConfigurationActionsArrayErrors[alertIndex] = alertConfigurationActionsErrors;
      }

      if (!alertConfigurationAction || !alertConfigurationAction.deviceGroup) {
        alertConfigurationActionsErrors.deviceGroup = i18next.t('messages.please-select-business-structure');
        alertConfigurationActionsArrayErrors[alertIndex] = alertConfigurationActionsErrors;
      }
    });

    if (alertConfigurationActionsArrayErrors.length) {
      errors.alertConfigurationActions = alertConfigurationActionsArrayErrors;
    }
  }

  return errors;
};

@connect(state => {
  return {
    form: state.form
  }
})
class EventConfigurationForm extends React.Component {

  constructor(props) {
    super(props);

    let initData = {
      name: null,
      description: null,
      alertConfigurationActions: [],
      alertExemptTimes: []
    };

    if (this.props.alertConfiguration) {
      initData.name = this.props.alertConfiguration.name;

      initData.description = this.props.alertConfiguration.description;

      initData.status = this.props.alertConfiguration.alertConfigurationStatus ?
        { 
          label: i18next.t(`alert-configuration-statuses.${this.props.alertConfiguration.alertConfigurationStatus.token}`),
          value: this.props.alertConfiguration.alertConfigurationStatus.id
        } : null;

      initData.alertConfigurationActions = this.props.alertConfiguration.alertConfigurationActions
        .filter(alertConfigurationAction => !alertConfigurationAction.archived)
        .map(alertConfigurationAction => {
          return {
            id: alertConfigurationAction.id,
            duration: alertConfigurationAction.duration / 60,
            alertLevel: { value: alertConfigurationAction.alertLevel.id, label: i18next.t(`alert-levels.${alertConfigurationAction.alertLevel.token}`), alertLevel: alertConfigurationAction.alertLevel },
            action: { value: alertConfigurationAction.action.id, label: alertConfigurationAction.action.name, action: alertConfigurationAction.action },
            threshold: { value: alertConfigurationAction.threshold.id, label: alertConfigurationAction.threshold.archived ? `${alertConfigurationAction.threshold.name} (deleted)` : alertConfigurationAction.threshold.name, threshold: alertConfigurationAction.threshold },
            deviceGroup: { value: alertConfigurationAction.deviceGroup.id, label: alertConfigurationAction.deviceGroup.name, deviceGroup: alertConfigurationAction.deviceGroup },
            resolutionNotificationEnabled: alertConfigurationAction.resolutionNotificationEnabled,
            autoResolutionEnabled: alertConfigurationAction.autoResolutionEnabled
          };
        });

      initData.alertExemptTimes = this.props.alertConfiguration.alertExemptTimes
        .filter(alertExemptTime => !alertExemptTime.archived)
        .map(alertExemptTime => {
          return {
            id: alertExemptTime.id,
            startAtTime: alertExemptTime.startAtTime,
            endAtTime: alertExemptTime.endAtTime,
            monday: alertExemptTime.monday,
            tuesday: alertExemptTime.tuesday,
            wednesday: alertExemptTime.wednesday,
            thursday: alertExemptTime.thursday,
            friday: alertExemptTime.friday,
            saturday: alertExemptTime.saturday,
            sunday: alertExemptTime.sunday,
            allDay: alertExemptTime.startAtTime === 0 && alertExemptTime.endAtTime === (24 * 60 * 60)
          };
        });
    }

    this.state = {
        actions: null,
        alertLevels: null,
        thresholds: null,
        showDeleteModal: false,
        groups: null
    };

    this.props.initialize(initData);
    
    this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
  }

  componentDidMount() {
    ThresholdsService.listAll().then(response => {
      this.setState({ thresholds: response.thresholds });
    }).catch(error => {
      console.error(error); // TODO handle error
    });

    AlertLevelsService.listAll().then(response => {
      this.setState({ alertLevels: response.alertLevels });
    }).catch(error => {
      console.error(error); // TODO handle error
    });

    ActionsService.listAll().then(response => {
      this.setState({ actions: response.actions.filter(action => !action.archived) });
    }).catch(error => {
      console.error(error); // TODO handle error
    });

    GroupsService.listAll().then(response => {
      this.setState({ groups: response.groups });
    }).catch(error => {
      console.error(error); // TODO handle error
    });

    EventConfigurationStatusesService.listAll().then(response => {
      this.setState({
        statusOptions: response.statuses
                               .filter(status => status.token !== 'auto_resolved')
                               .map(status => ({label: i18next.t(`device-statuses.${status.token}`), value: status.id }))
      });
    }).catch(error => {
      console.error(error); // TODO handle error
    });

    TagsService.getDeviceCounts().then(response => {
      this.setState({counts: response.counts})
    }).catch(error => {
      console.error(error); // TODO handle error
    });
  }

  archiveAlertConfiguration() {
    EventConfigurationsService.archiveEventConfiguration(this.props.alertConfiguration.id).then(response => {
      this.setState({linkToList: true, successMessage: i18next.t('messages.event-configuration-archive-success'), errorMessage: null });
    }).catch(error => {
      console.error(error);
      this.setState({ linkToList: true, errorMessage: i18next.t('messages.event-configuration-archive-failure'), successMessage: null});
    });
  }

  toggleDeleteModal() {
    this.setState({
       showDeleteModal: !this.state.showDeleteModal
    });
  }

  render() {
    if (this.state.linkToList) {
      return (<Redirect to={{ pathname: '/config/events', state: { successMessage: this.state.successMessage, errorMessage: this.state.errorMessage } }} />);
    }

    if (this.state.actions && this.state.alertLevels && this.state.thresholds && this.state.groups && this.state.statusOptions && this.state.counts) {
      return (
        <div className="login-form">
          <form onSubmit={this.props.handleSubmit}>
            <div>
              <Field
                name="name"
                type="text"
                component={TextInput}
                label={ i18next.t('form-labels.name') }
              />
            </div>
            <div>
              <Field
                name="description"
                type="text"
                component={TextInput}
                label={ i18next.t('form-labels.description') }
              />
            </div>
            <div>
              <label>{ i18next.t('form-labels.status') }</label>
              <Field
                name="status"
                options = {this.state.statusOptions}
                component={SelectInput}
              />
            </div>
            <hr />
            <div className="op-content-box-level-2 action-wrap">
              <FieldArray
                name="alertExemptTimes"
                component={AlertExemptTimesEntry}
                onError={(error) => { console.error(error); /* TODO handle error */ }}
              />
            </div>
            <hr />
            <div className="op-content-box-level-2 action-wrap">
              <FieldArray
                name="alertConfigurationActions"
                component={AlertConfigurationActionTypeEntry}
                actions={this.state.actions}
                alertLevels={this.state.alertLevels}
                availableThresholds={this.state.thresholds}
                groups={this.state.groups}
                deviceCounts = {this.state.counts}
              />
            </div>

            <hr />

            <ul className="list-inline clearfix">
              <li><button type="submit" className="btn btn-primary btn-block">{ i18next.t('form-labels.save') }</button></li>
              <li><Link to={ this.props.backLinkWithParams ? this.props.backLinkWithParams.link : `/config/events`}><button className="btn btn-default">{ i18next.t('form-labels.cancel') }</button></Link></li>
              {this.props.alertConfiguration &&
              <PageLevelAccess to='/config/events/edit/:eventConfigurationId#delete'>
                <li className="pull-right"><a className="btn btn-danger" onClick={this.toggleDeleteModal}>{ i18next.t('form-labels.archive') }</a></li>
              </PageLevelAccess>}
            </ul>

            <Modal show={this.state.showDeleteModal} onHide={this.toggleDeleteModal.bind(this)}>
              <Modal.Header closeButton>
                <Modal.Title>{ i18next.t('pages.event-configurations.archive-event') } {this.props.form.EventConfigurationForm.values ? this.props.form.EventConfigurationForm.values.name : ''}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>{ i18next.t('pages.event-configurations.are-you-sure') }</p> <br />
              </Modal.Body>
              <Modal.Footer>
                <a className="btn btn-danger" onClick={this.archiveAlertConfiguration.bind(this)}>{ i18next.t('form-labels.archive') }</a>
                <Button onClick={this.toggleDeleteModal.bind(this)}>{ i18next.t('form-labels.cancel') }</Button>
              </Modal.Footer>
            </Modal>
          </form>
        </div>
      );
    } else {
      return (
        <div className="loader">{ i18next.t('loading') }</div>
      );
    }
  }
}

const DayCheckbox = ({exemption, dayOfWeek, dayIndex}) => (
  <li>
    <Field
      className="inline"
      name={`${exemption}.${dayOfWeek}`}
      component={CheckboxInput}
      label={moment.weekdaysShort(dayIndex)}
      type="checkbox"
    />
  </li> 
);

const AlertExemptTimesEntry = ({fields, meta: { error }, onError}) => {
  const [showCalendarModal, setShowCalendarModal] = useState(false);
  const [calendar, setCalendar] = useState(null);

  useEffect(() => {
    // Setting Monday as first day of the week.
    moment.updateLocale('en', {week: {dow : 1}});
    moment.locale(i18next.language);
  }, []);

  const getCalendar = useCallback(() => {
    setShowCalendarModal(true);

    EventConfigurationsService.getCalendar(fields.getAll()).then(response => {
      setCalendar(response.calendar);
      setShowCalendarModal(false);
    }).catch(error => {
      console.error(error);
      onError(error);
      setShowCalendarModal(false);
    });
  }, []);

  const updateAllDayTime = useCallback((index, allDay) => {
    if (allDay == true) {
      fields.get(index).startAtTime = 0;
      fields.get(index).endAtTime = 24 * 60 * 60;
    } else {
      fields.get(index).startAtTime = 8 * 60 * 60;
      fields.get(index).endAtTime = 20 * 60 * 60;
    }
  }, []);
  
  const addEntry = useCallback(() => {
    fields.unshift({ 
      hasOvernightEntry: false, 
      monday: true, tuesday: true, wednesday: true, thursday: true, friday: true, saturday: true, sunday: true, 
      allDay: false, 
      startAtTime: 8 * 60 * 60, endAtTime: 20 * 60 * 60 
    });
  }, []);

  return (
    <div className="row">
      <div className="col-sm-12">
        <ul className="list-inline clearfix remove-margin-bottom actions-header">
          <li className="pull-left"><h4 className="remove-margin-bottom">{ i18next.t('pages.event-configurations.exempt-times') }</h4></li>
          <li className="pull-right">

            {/* TODO <span onClick={() => getCalendar()}>View as Calendar</span> &nbsp; */}

            <button className="btn btn-default btn-sm" type="button" onClick={addEntry}>
              { i18next.t('form-labels.add-exempt-time') }
            </button>
          </li>
        </ul>
      </div>

      {fields.map((field, index) => 
        <div className="col-sm-12 oc-mini-card" key={index}>
          <div className="inner">
            <div className="row">
              <div className="col-sm-12 col-md-12" style={{paddingBottom:'10px'}} >
                <Field
                  className="inline"
                  name={`${field}.allDay`}
                  component={CheckboxInput}
                  label={ i18next.t('form-labels.all-day') } 
                  type="checkbox"
                  defaultValue={false}
                  onChange={(_, newValue) => updateAllDayTime(index, newValue)}
                />
              </div>
              { fields.get(index).allDay ? 
                <div className="col-sm-12 col-md-4"> </div> :
                <div className="col-sm-12 col-md-4">
                  <Field
                    name={`${field}.startAtTime`}
                    type="text"
                    component={TimePickerInput}
                    valueType="milliseconds"
                    label={ i18next.t('form-labels.start-at-time') }/>
                </div>     
              }
              { fields.get(index).allDay ? 
                <div className="col-sm-12 col-md-4"> </div> :
                <div className="col-sm-12 col-md-4">
                  <Field
                    name={`${field}.endAtTime`}
                    type="text"
                    component={TimePickerInput}
                    valueType="milliseconds"
                    label={ i18next.t('form-labels.end-at-time') }/>
                </div> 
              }
              <div className="col-sm-12 col-md-4 form-group action-button">
                <label>&nbsp;</label>
                <button
                  type="button"
                  title={ i18next.t('form-labels.remove-action') }
                  className="btn btn-danger"
                  onClick={() => { fields.remove(index); }}>{ i18next.t('form-labels.remove-exempt-time') }</button>
              </div>
              {
                fields.get(index).endAtTime < fields.get(index).startAtTime ?
                <div className="col-sm-12 col-md-12" style={{paddingBottom:'10px'}} >
                  <i>* { i18next.t('form-labels.overnight-note') }</i>
                </div>
                : null
              }
              <div className="col-sm-6">
                <label>{ i18next.t('form-labels.days-of-week-exempt') }</label>
                <ul className="list-inline clearfix">
                  <DayCheckbox exemption={field} dayOfWeek="monday" dayIndex={1} />
                  <DayCheckbox exemption={field} dayOfWeek="tuesday" dayIndex={2} />
                  <DayCheckbox exemption={field} dayOfWeek="wednesday" dayIndex={3} />
                  <DayCheckbox exemption={field} dayOfWeek="thursday" dayIndex={4} />
                  <DayCheckbox exemption={field} dayOfWeek="friday" dayIndex={5} />
                  <DayCheckbox exemption={field} dayOfWeek="saturday" dayIndex={6} />
                  <DayCheckbox exemption={field} dayOfWeek="sunday" dayIndex={0} />
                </ul>                  
              </div>
            </div>
          </div>
        </div>
      )}
      
      { error && <div className="error">{error}</div> }

      <Modal show={showCalendarModal} onHide={() => setShowCalendarModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Exempt Time Calendar View</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            calendar ? 
            <div>
              <table>
                <tr><th>Day</th><th>Time Ranges</th></tr>
                {Object.entries(calendar).map((entry) => {
                  return (
                    <tr key={entry[0]}>
                      <td>{entry[0]}</td>
                      <td>{entry[1].map(range => `${range.startTime} to ${range.endTime}`)}</td>
                    </tr>
                    )
                })}
              </table>
            </div>
            :
            <div>Loading...</div>
          }
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowCalendarModal(false)}>{ i18next.t('form-labels.ok') }</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

const AlertConfigurationActionTypeEntry = connect((state) => ({ me: state.user.me }))(({me, groups, availableThresholds, alertLevels, actions, deviceCounts, fields, meta: { error }}) => {
  const [selectedThresholds, setSelectedThresholds] = useState(fields.map((_, index) => fields.get(index).threshold?.threshold));
  
  const thresholdOptions = availableThresholds.map((threshold) => ({ value: threshold.id, label: threshold.archived ? `${threshold.name} deleted` : threshold.name, threshold: threshold }));
  const alertLevelOptions = alertLevels.map(alertLevel => ({ value: alertLevel.id, label: i18next.t(`alert-levels.${alertLevel.token}`), alertLevel: alertLevel }));
  const actionOptions = actions.map(action => ({ value: action.id, label: action.name, action: action }));
  const groupOptions = groups.sort((a, b) => {return b.displayOrder - a.displayOrder}).map(group => ({ value: group.id, label: group.name, deviceGroup: group }));
  const supportForAutoResolutionEnabledFlag = me.enterprise.enterprisePreferences.find(pref => pref.token === 'ALERT_SERVICE_AUTO_RESOLUTION_ENABLED');
  const supportForAutoResolutionEnabled = supportForAutoResolutionEnabledFlag && supportForAutoResolutionEnabledFlag.numericValue === 1;

  const updateCondition = useCallback((newValue) => {
    let updatedThresholds = [...selectedThresholds];
    updatedThresholds.unshift(newValue.threshold);
    setSelectedThresholds(updatedThresholds);
  }, []);

  const addCondition = useCallback((fields) => {
    fields.unshift({ resolutionNotificationEnabled: true, autoResolutionEnabled: true });
  }, []);

  const removeCondition = useCallback((fields, index) => {
    fields.remove(index);
  }, []);

  const SelectIconSingleValue = ({ children, ...props }) => (<components.SingleValue {...props}>{SelectIconRenderer(props.selectProps.value)}</components.SingleValue>);
  const SelectIconOption = (props) => (<components.Option {...props}>{SelectIconRenderer(props.data)}</components.Option>);

  return (
    <div className="row">
      <div className="col-sm-12">
        <ul className="list-inline clearfix remove-margin-bottom actions-header">
          <li className="pull-left"><h4 className="remove-margin-bottom">Conditions</h4></li>
          <li className="pull-right">
            <button className="btn btn-default btn-sm" type="button" onClick= {() => addCondition(fields)} >
              { i18next.t('form-labels.add-condition') }
            </button>
          </li>
        </ul>
      </div>

      {fields.map((field, index) =>
        <div className="col-sm-12 oc-mini-card" key={index}>
          <div className="inner">
            <div className="row">
              <div className="col-sm-12 col-md-6 form-group">
                <label>{ i18next.t('form-labels.threshold') }</label>
                <Field
                  name={`${field}.threshold`}
                  options={thresholdOptions}
                  isClearable={false}
                  isSearchable={false}
                  component={SelectInput}
                  components={{ SingleValue : SelectIconSingleValue, Option : SelectIconOption }}
                  onChange={(newValue) => updateCondition(newValue)}
                />
              </div>

              <div className="col-sm-8 col-md-4 form-group align-with-selects">
                <Field
                  name={`${field}.duration`}
                  type='number'
                  component={TextInput}
                  label={ i18next.t('form-labels.duration-in-minutes') }
                />
              </div>
              <div className="col-sm-2 col-md-2 form-group">
                &nbsp;
              </div>
            </div>
            <div className="row">
              { selectedThresholds[index] &&
                <div className="col-sm-12 col-md-6 form-group">
                  <div className="card-data-cell remove-border-left">
                    <label>{ selectedThresholds[index].deviceDataClassification ? i18next.t('form-labels.threshold-measurement-type') : i18next.t('form-labels.threshold-measurement') }</label>
                    <p className="measurement-p">
                      {
                        selectedThresholds[index].archived ?
                        <span> (deleted) </span> :
                        <span>
                          <img src={`${config.WEB_BASE_URL}/images/icon/sensor_${selectedThresholds[index].thresholdClassification.token}.svg`} height="16" />&nbsp;
                          {selectedThresholds[index].deviceDataType?.name ?? (selectedThresholds[index].deviceDataClassification?.name ?? "Unknown")}&nbsp;
                          <span className="threshold-evaluation">{selectedThresholds[index].thresholdEvaluationType.shortForm}</span>&nbsp;
                          {FormatHelper.formatMeasurement(selectedThresholds[index])}
                        </span>
                      }
                    </p>
                  </div>
                </div>
              }
              <div className="col-sm-12 col-md-6 form-group">
                <label>{ i18next.t('form-labels.originating-from') }</label>
                <Field
                  name={`${field}.deviceGroup`}
                  options={groupOptions}
                  isClearable={false}
                  isSearchable={false}
                  component={SelectInput}
                />
              </div>
              { selectedThresholds[index] &&
                <div className="col-sm-12 col-md-6 form-group">
                    <div className="card-data-cell remove-border-left">
                      <label>{ i18next.t('form-labels.will-only-match-assets-with-tags') }</label>
                      {selectedThresholds[index].tags.length > 0 ?
                        selectedThresholds[index].tags.map((tag, index) => <p className="alert-tag" key = {index}>{tag.name} <span>{deviceCounts[tag.id].deviceCount}</span></p>) :
                      <p>{ i18next.t('none') }</p>}
                    </div>
                </div>
              }
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-6 form-group">
                <label>{ i18next.t('form-labels.level') }</label>
                <Field
                  name={`${field}.alertLevel`}
                  options={alertLevelOptions}
                  isClearable={false}
                  isSearchable={false}
                  component={SelectInput}
                  components={{ SingleValue : SelectIconSingleValue, Option : SelectIconOption }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-6 form-group">
                <label>{ i18next.t('form-labels.action-type') }</label>
                <Field
                  name={`${field}.action`}
                  options={actionOptions}
                  clearable={false}
                  searchable={false}
                  component={SelectInput}
                />
              </div>
            </div>
            {
              supportForAutoResolutionEnabled ?
              <div className="row">
                <div className="col-sm-12 col-md-6 form-group">
                  <Field
                    className="inline"
                    name={`${field}.resolutionNotificationEnabled`}
                    component={CheckboxInput}
                    type="checkbox"
                    label={ i18next.t('form-labels.notification-threshold-resolution') }
                  />
                </div>
                <div className="col-sm-12 col-md-6 form-group">
                  <Field
                    className="inline"
                    name={`${field}.autoResolutionEnabled`}
                    component={CheckboxInput}
                    type="checkbox"
                    label={ i18next.t('form-labels.automatically-mark-resolved') }
                  />
                </div>
              </div> : null
            }

            <div className="row">
              <div className="col-sm-12 col-md-6 form-group action-button">
                <button
                  style={{marginTop: '15px'}}
                  type="button"
                  title={ i18next.t('form-labels.remove-action') }
                  className="btn btn-danger"
                  onClick={() => removeCondition(fields, index)}>{ i18next.t('form-labels.remove-condition') }</button>
              </div>
            </div>
          </div>
        </div>
      )}

      { error && <div className="error"> {error} </div> }
    </div>
  );
});

export default reduxForm({ form: "EventConfigurationForm", validate })(EventConfigurationForm);
